import CardSystem from '../CardSystem';
import TransformComponent from '../../../Component/Transform';
import CardComponent from '../../../Component/Level/Card';
import StreakTask from '../Task/StreakTask';
import { PlaySound } from '../../Audio/AudioHelper';
import { AudioTrackType } from '../../Audio/AudioClip';
import CardAnimationTask from '../../../Utility/Task/CardAnimationTask';
import { ICardStateTaskData } from '../../../State/Card/ICardState';
import StreakBar from '../../../Prototype/UI/Level/StreakBar';
import Point from '../../../Utility/Point';

export default function MatchCardAnimation(
    system: CardSystem,
    taskData: ICardStateTaskData
): void {
    let streakAudioIndex = system.store.getState().levelState.cardsState
        .matchSequence.length;
    if (streakAudioIndex > 10) streakAudioIndex = 10;

    PlaySound(
        [
            'rising-tones1',
            'rising-tones2',
            'rising-tones3',
            'rising-tones4',
            'rising-tones5',
            'rising-tones6',
            'rising-tones7',
            'rising-tones8',
            'rising-tones9',
            'rising-tones10',
        ][streakAudioIndex - 1]
    );

    StreakBar.instance.update();

    //PlaySound('Cardplay.mp3');
    //CardStateAnimationHelper.showPreviousCard(system.getCardsFolded());
    const card = system.getCardByID(taskData.cards[0]);

    // Add to cards container to set correct position.
    system.cardsContainer.addChild(card);

    // Set position.
    const cardComponent = card.getComponent(CardComponent);
    card.getComponent(TransformComponent).position.set(
        cardComponent.x,
        cardComponent.y
    );

    // Add to stack container maintaining previous global position.
    system.stackContainer.addChild(card);

    const task = new CardAnimationTask(
        taskData,
        system,
        'CardMatch',
        card,
        {
            cardScore: taskData.cardScore,
            coinsCollected: taskData.coinsCollected,
            target: Point.Zero,
        },
        true
    );

    system.taskQueue.queueNext(task);

    // if (taskData.coinsCollected) {
    //     const coinText: GameObject = GameObject.findFirstByName(
    //         LevelHUDHandler.COIN_BAR_NAME
    //     ).findChildByName('coin_text');
    //     const coinTask = new CardAnimationTask(
    //         taskData,
    //         system,
    //         'Counter',
    //         coinText,
    //         taskData,
    //         true
    //     );
    //     system.taskQueue.queue(coinTask);
    // }
    system.taskQueue.queue(new StreakTask());
}
